import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import resources from "./locales/resources";

export type Language = "en" | "ar";

export const defaultNS = "ns1";

i18next.use(initReactI18next).init({
  // debug: true,
  fallbackLng: "ar",
  defaultNS,
  resources,
});

export const SetCurrentLanguage = (language: Language) => {
  i18next.changeLanguage(language);
  // isRTL = language === 'ar';
  // moment.locale(locale);
};

export const getCurrentLanguage = () => i18next.language;

export default i18next;
